export default __webpack_public_path__ + "static/into-the-light-bfc3f1c2fe23d243f0425abc7031a762.mp3";